export const INTERFACE_ELEMENTS = {
  HEADER: "header",
  QR_CODE: "qrCode",
  FOOTER: "footer",
  CONTACTS: "contacts",
} as const;
